<template>
    <div class="preloader-wrapper small active" v-if="active">
        <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
                <div class="circle"></div>
            </div>
            <div class="gap-patch">
                <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
                <div class="circle"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['active']
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/InlineLoader.vue